import { z } from 'zod';

export const passwordFormSchema = z.object({
  currentPassword: z.string().min(3),
  newPassword: z.string().min(3),
});
